const fields = [
  {
    title: '序号', // 显示的名称
    dataIndex: 'index', // 请求的参数
    scopedSlots: {
      customRender: 'subscript'
    },
    alias: false, // 不携带
    width: 70, // 表格的宽
    fixed: 'left' // 横向滚动时固定
  },
  {
    title: '公开号',
    dataIndex: 'publication_number_sear',
    scopedSlots: {
      customRender: 'TextAction'
    },
    width: 140, // 表格的宽
    fixed: 'left' // 横向滚动时固定
  },
  {
    title: '申请号',
    dataIndex: 'application_num_sear',
    width: 150
  },
  {
    title: '专利标题',
    dataIndex: 'title_sear',
    width: '150px'
  },
  // {
  //   title: '申请日',
  //   dataIndex: 'application_date',
  //   width: '140px'
  // },
  // {
  //   width: '120px',
  //   dataIndex: 'publication_country_stat',
  //   title: '国别'
  // },
  {
    title: '专利状态',
    dataIndex: 'patent_status_stat',
    width: '90px',
    scopedSlots: {
      customRender: 'CompetitorStatus'
    }
  },
  {
    title: '专利类型',
    dataIndex: 'patent_type_cn_stat',
    width: '100px'
  },
  {
    title: '公开日',
    dataIndex: 'publication_date',
    width: '97px'
  },
  // {
  //   title: '主IPC分类号',
  //   dataIndex: 'ipc_main_stat',
  //   width: '120px'
  // },
  // {
  //   title: '申请人(规)',
  //   dataIndex: 'applicants_normal_stat',
  //   width: 180
  // },
  // {
  //   title: '同族数量',
  //   dataIndex: 'family_count',
  //   width: 100
  // },
  // {
  //   title: '最早优先权日',
  //   dataIndex: 'priority_day',
  //   width: 150
  // }
]

const slotOpt = [
  {
    slot: 'TextAction',
    component: 'TextAction'
  },
  {
    slot: 'CompetitorStatus',
    component: 'CompetitorStatus'
  }
]

module.exports = {
  fields,
  slotOpt
}